import { AxiosInstance } from 'axios';
import { IUserIdentity } from 'cd-eft/security/IUserIdentity';

export class EftAuthAxiosInterceptor {
  private readonly _axiosInstance: AxiosInstance;
  private readonly _userIdentity: IUserIdentity;

  private _requestInterceptor?: number = undefined;
  private _responseInterceptor?: number = undefined;

  constructor(axiosInstance: AxiosInstance, userIdentity: IUserIdentity) {
    this._axiosInstance = axiosInstance;
    this._userIdentity = userIdentity;
  }

  activate() {
    if (this._requestInterceptor === undefined) {
      this._requestInterceptor = this._axiosInstance.interceptors.request.use(
        this._requestHandler.bind(this), //necessary to bind in order to retain object instance context
        this._requestErrorHandler.bind(this) //necessary to bind in order to retain object instance context
      );
    }
    if (this._responseInterceptor === undefined) {
      this._responseInterceptor = this._axiosInstance.interceptors.response.use(
        this._responseHandler.bind(this), //necessary to bind in order to retain object instance context
        this._responseErrorHandler.bind(this) //necessary to bind in order to retain object instance context
      );
    }
  }

  deactivate() {
    if (this._requestInterceptor !== undefined) {
      this._axiosInstance.interceptors.request.eject(this._requestInterceptor);
      this._requestInterceptor = undefined;
    }
    if (this._responseInterceptor !== undefined) {
      this._axiosInstance.interceptors.response.eject(this._responseInterceptor);
      this._responseInterceptor = undefined;
    }
  }

  private _requestHandler(config) {
    // console.warn('EftAuthAxiosInterceptor.requestHandler');
    const accessToken = this._userIdentity.accessToken;
    const authorization = 'Bearer ' + accessToken;
    config.headers['Authorization'] = authorization;
    return config;
  }

  private _requestErrorHandler(error) {
    // console.error('EftAuthAxiosInterceptor.requestErrorHandler');
    return Promise.reject(error);
  }

  private _responseHandler(response) {
    // console.warn('EftAuthAxiosInterceptor.responseHandler');
    return response;
  }

  private async _responseErrorHandler(error) {
    console.error('EftAuthAxiosInterceptor.responseErrorHandler');
    const response = error.response;
    // console.log('response', response);
    if (response && response.status) {
      if (response.status === 401 || response.status === 403) {
        const config = error.config;
        //   console.log('config', config);
        if (!config._retry) {
          config._retry = true;
          try {
            // try refreshing the current security context
            await this._userIdentity.refresh();
  
            // console.log('EftAuthAxiosInterceptor._responseErrorHandler(): \nCASE A');
            return this._axiosInstance(config);
          } catch {
            //REFRESH TOKEN FAILURE, LOGIN SESSION CANNOT BE RECOVERED
            //TODO: FORCE REDIRECT TO LOGIN PAGE
            // console.log('EftAuthAxiosInterceptor._responseErrorHandler(): \nCASE B');
            // Run user identity logout routine
            await this._userIdentity.logout();
            // Handler from AppVM to do the redirecting to logout
            if (this._userIdentity.expireHandler) this._userIdentity.expireHandler();
            return Promise.reject(error);
          }
        }
      }
    }
    // console.log('EftAuthAxiosInterceptor._responseErrorHandler(): \nCASE C');
    // await this._userIdentity.logout();
    return Promise.reject(error);
  }
}
